import { useEffect, useState } from 'react';

export const useDetectAdBlock = () => {
  const [adBlockDetected, setAdBlockDetected] = useState(false);

  useEffect(() => {
    // grab a domain from https://github1s.com/gorhill/uBlock/blob/master/docs/tests/hostname-pool.js
    const ctrl = new AbortController();
    const url =
      'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js'; //'https://www3.doubleclick.net';
    fetch(url, {
      method: 'HEAD',
      mode: 'no-cors',
      cache: 'no-store',
      signal: ctrl.signal,
    })
      .then(({ redirected }) => {
        if (redirected) setAdBlockDetected(true);
      })
      .catch((error) => {
        // don't detect if an abort error caused by clean up
        if (error.name !== 'AbortError') {
          setAdBlockDetected(true);
        }
      });
    return () => ctrl.abort();
  }, []);

  return adBlockDetected;
};
